var map = {
	"./desktop/image-gallery-cone.jpg": 6014,
	"./desktop/image-gallery-milkbottles.jpg": 3559,
	"./desktop/image-gallery-orange.jpg": 2429,
	"./desktop/image-gallery-sugarcubes.jpg": 4155,
	"./desktop/image-graphic-design.jpg": 6439,
	"./desktop/image-header.jpg": 4179,
	"./desktop/image-photography.jpg": 8427,
	"./desktop/image-stand-out.jpg": 1809,
	"./desktop/image-transform.jpg": 230,
	"./down-arrow.png": 5979,
	"./favicon-32x32.png": 574,
	"./icon-arrow-down.svg": 2449,
	"./icon-facebook.svg": 5221,
	"./icon-hamburger.svg": 4262,
	"./icon-instagram.svg": 7199,
	"./icon-pinterest.svg": 6645,
	"./icon-twitter.svg": 3986,
	"./image-emily.jpg": 4489,
	"./image-jennie.jpg": 1386,
	"./image-thomas.jpg": 2399,
	"./logo.svg": 3914,
	"./mobile/image-gallery-cone.jpg": 200,
	"./mobile/image-gallery-milkbottles.jpg": 6025,
	"./mobile/image-gallery-orange.jpg": 2643,
	"./mobile/image-gallery-sugar-cubes.jpg": 1826,
	"./mobile/image-graphic-design.jpg": 293,
	"./mobile/image-header.jpg": 645,
	"./mobile/image-photography.jpg": 6869,
	"./mobile/image-stand-out.jpg": 2263,
	"./mobile/image-transform.jpg": 8912
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;